import { CircularProgress, Stack } from "@mui/material"
import { useEffect } from "react"
import { rootStore, useStores } from "stores/root-store"
import { MainComponent, ContentWrapper, AppLoadingContainer } from "components/common-styles"
import { useParams } from "react-router-dom"
import BreadcrumbHeader from "components/common/breadcrumb-header"
import { observer } from "mobx-react-lite"
import DGItemProfileViewDetails from "components/dg-item-profile/details-info"
import DGItemProfileForm from "components/dg-item-profile/dg-item-profile-form"

const DGItemProfileDetail = () => {
  const { id } = useParams()

  const onEditClicked = () => {
    rootStore.setOpenForm(true)
  }

  const { DGItemProfileStore } = useStores()

  useEffect(() => {
    DGItemProfileStore.loadDetailData(id)
  }, [DGItemProfileStore, id, DGItemProfileStore.forceReload])

  if (DGItemProfileStore.isLoading || !DGItemProfileStore.detailInfo) {
    return (
      <AppLoadingContainer>
        <CircularProgress size={64} />
      </AppLoadingContainer>
    )
  }

  const handleClose = () => {
    rootStore.setOpenForm(false)
  }

  const handleSave = () => {
    handleClose()
    DGItemProfileStore.setForceReload()
  }

  if (rootStore.openForm) return <DGItemProfileForm onSave={handleSave} onClose={handleClose} />

  return (
    <>
      <BreadcrumbHeader />
      <MainComponent component="main">
        <ContentWrapper maxWidth={"xl"}>
          <DGItemProfileViewDetails onEditClicked={onEditClicked} />
        </ContentWrapper>
      </MainComponent>
    </>
  )
}

export default observer(DGItemProfileDetail)
